import App from '@components/blog/App.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js'

generateApplication(
  App,
  "#blog-app",
  {
    injections: [{
      name: 'axios', module: generateAxiosInstance(hostApiKey, '/api/v1/pub/')
    }, {
      name: 'locale', module: locale
    }, {
      name: 'translations', module: translations
    }, {
      name: 'tag', module: typeof tag === 'undefined' ? null : tag
    }],
  }
)